<script>
    import Conexoes from "../../Classes/Conexoes";
    import Constantes from "../../Classes/Constantes";
    import DropSelecao from "../../componentes_basicos/DropSelecao.svelte";
    import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
    import Anamneses from "./Anamneses.svelte";
    import { ItemInserir, Tipo } from "../../Classes/ItemInserir.js";
    import InserirDadosBasico from "../../Componentes/InsercaoDados/InserirDadosBasico.svelte";
    import AlteraDadosBasico from "../../Componentes/AlteracaoDados/AlteraDadosBasico.svelte";
    import { Paper, Accordion, Button, Title } from "@svelteuidev/core";
    import { DadosLogin } from "../../Classes/Stores";
    import TelasAcessoNaoAutorizado from "./TelasAcessoNaoAutorizado.svelte";
    import { onMount } from "svelte";
    import ListaDeTestes from "./ListaDeTestes.svelte";
    import TestesCorrida from "./TestesCorrida.svelte";
    import Vdot from "./vdot.svelte";
    import ExibePlanoCorrida from "./ExibePlanoCorrida.svelte";

    const conexao = new Conexoes();

    export let id_assessoria = $DadosLogin.id_assessoria; // colocar logica depois
    let api_insercao = Constantes.api_insere_edita_metas_zonas;
    let apiConsultaEdicao = Constantes.api_consultar_padrao;
    let modoInsert = false;
    let query_code_carregar_edicao =
        Constantes.query_code_consulta_usuarios_metas_zonas_update;
    let id_usuario;
    let isLoading = false;
    let result = {};
    let PaceEditavel = true;
    let itensContato = [
        new ItemInserir({
            rotulo: "Nome",
            nomeColuna: "nome_usuario",
            tamanho: 50,
            tipo: Tipo.TEXTO,
            readonly: true,
        }),
        new ItemInserir({
            rotulo: "Email",
            nomeColuna: "email",
            tamanho: 50,
            tipo: Tipo.TEXTO,
            readonly: true,
        }),
        new ItemInserir({
            rotulo: "Telefone",
            nomeColuna: "telefone",
            tamanho: 50,
            tipo: Tipo.TEXTO,
            readonly: true,
        }),
    ];
    let itens = [
        new ItemInserir({
            rotulo: "id_usuario",
            nomeColuna: "id_usuario",
            tamanho: 50,
            tipo: Tipo.HIDDEN,
            valor: id_usuario,
        }),
        new ItemInserir({
            rotulo: "Meta",
            nomeColuna: "meta",
            tamanho: 100,
            tipo: Tipo.TEXTO,
            obrigatorio: false,
        }),
        new ItemInserir({
            rotulo: "Pace Z1",
            nomeColuna: "pace_z1",
            tamanho: 20,
            tipo: Tipo.TEXTO,
            obrigatorio: false,
        }),
        new ItemInserir({
            rotulo: "Pace Z2",
            nomeColuna: "pace_z2",
            tamanho: 20,
            tipo: Tipo.TEXTO,
            obrigatorio: false,
        }),
        new ItemInserir({
            rotulo: "Pace Z3",
            nomeColuna: "pace_z3",
            tamanho: 20,
            tipo: Tipo.TEXTO,
            obrigatorio: false,
        }),
        new ItemInserir({
            rotulo: "Pace Z4",
            nomeColuna: "pace_z4",
            tamanho: 20,
            tipo: Tipo.TEXTO,
            obrigatorio: false,
        }),
        new ItemInserir({
            rotulo: "Pace Z5",
            nomeColuna: "pace_z5",
            tamanho: 20,
            tipo: Tipo.TEXTO,
            obrigatorio: false,
        }),
        new ItemInserir({
            rotulo: "Ativado",
            nomeColuna: "ativado",
            tamanho: 5,
            tipo: Tipo.TG,
            obrigatorio: false,
        }),
        new ItemInserir({
            rotulo: "id_assessoria",
            nomeColuna: "id_assessoria",
            tamanho: 50,
            valor: id_assessoria,
            tipo: Tipo.HIDDEN,
        }),
    ];
    let config = {
        api: Constantes.api_consultar_padrao,
        query_code: "consulta_usuarios_assessorias",
        campos_pesquisaveis: ["nome_usuario", "meta", "ativado"],
        colunas_exibidas: ["nome_usuario", "meta", "ativado"],
        coluna_saida: "id",
        titulo: "Selecione o usuário",
        selecaoUnica: true,
        parametro_adicional: id_assessoria,
    };

    async function buscaMetasZonas() {
        isLoading = true;
        modoInsert = false;
        let query = Constantes.query_code_consulta_usuarios_metas_zonas;
        if (id_assessoria == 0) {
            query = Constantes.query_code_consulta_usuarios_metas_zonas_usuario;
        }
        result = await conexao.conecta(Constantes.api_consultar_padrao, {
            query_code: query,
            id_assessoria: id_assessoria,
            id_usuario: id_usuario,
        });
        if ((result && result.length == 0) || (result && !result[0].id)) {
            modoInsert = true;
        }
        isLoading = false;
    }
    function selecionado(e) {
        id_usuario = "";
        console.log("Selecionado", e.detail);
        id_usuario = e.detail.id;
        itens[0].valor = id_usuario;
        buscaMetasZonas();
    }
    onMount(() => {
        if (id_assessoria == 0) {
            id_usuario = $DadosLogin.id_usuario;
            PaceEditavel = false;
            buscaMetasZonas();
        }
    });
</script>

<br />
<br />
<br />
<br />
<LoadingTela {isLoading} />
<div class="back">
    {#if $DadosLogin.id_assessoria && $DadosLogin.id_assessoria > 0}
        <DropSelecao {config} on:selecionado={selecionado} />
    {/if}
    {#if id_usuario}
        <div class="container">
            <Accordion
                multiple
                chevronPosition="left"
                variant="separated"
                defaultValue={"Item " + 1}
            >
            {#if id_usuario && id_assessoria}
             {#if !isLoading && result && result[0].id}
            <Accordion.Item value={"PLANOS DE TREINOS"}>
                    <div slot="control">
                        <Title order={4} color="#3659fc"
                            >{"PLANOS DE TREINOS"}</Title
                        >
                    </div>

                    <ExibePlanoCorrida id_usuario={id_usuario} />
                        
                   
                </Accordion.Item>
                {/if}
                 {/if}
                <Accordion.Item value={"PERFIL DE CORRIDA"}>
                    <div slot="control">
                        <Title order={4} color="#3659fc"
                            >{"PERFIL DE CORRIDA"}</Title
                        >
                    </div>

                    {#if id_usuario && id_assessoria}
                        {#if !isLoading && result && result[0].id}
                            <p>Edite os dados abaixo com o perfil do atleta:</p>
                            <AlteraDadosBasico
                                id={result[0].id}
                                apiEdicao={api_insercao}
                                {apiConsultaEdicao}
                                {itens}
                                {query_code_carregar_edicao}
                                textoBotaoEditar={"Salvar"}
                                deleta={false}
                                edita={PaceEditavel}
                            />
                        {:else if modoInsert}
                            <InserirDadosBasico api={api_insercao} {itens} />
                        {/if}
                    {/if}
                </Accordion.Item>
                {#if !isLoading && result && result[0].id}
                    <Accordion.Item value={"DADOS DE CONTATO"}>
                        <div slot="control">
                            <Title order={4} color="#3659fc"
                                >{"DADOS DE CONTATO"}</Title
                            >
                        </div>

                        <AlteraDadosBasico
                            id={result[0].id}
                            apiEdicao={api_insercao}
                            {apiConsultaEdicao}
                            itens={itensContato}
                            {query_code_carregar_edicao}
                            textoBotaoEditar={"Salvar"}
                            deleta={false}
                            edita={false}
                            titulo={"Dados de contato"}
                        />
                    </Accordion.Item>
                {/if}
                {#if !isLoading && result && result[0].id}
                <Accordion.Item value={"CALCULADORA DE PACES"}>
                    <div slot="control">
                        <Title order={4} color="#3659fc"
                            >{"CALCULADORA DE PACES"}</Title
                        >
                    </div>

                    <Vdot  {id_assessoria} {id_usuario} />
                </Accordion.Item>
                <Accordion.Item value={"TESTES DE CORRIDA REALIZADOS"}>
                    <div slot="control">
                        <Title order={4} color="#3659fc"
                            >{"TESTES DE CORRIDA REALIZADOS"}</Title
                        >
                    </div>

                    {#if id_usuario && id_assessoria}
                        <h6>Históricos de teste</h6>
                        <ListaDeTestes
                            {id_usuario}
                            tabela={"teste_corrida"}
                            podeDeletar={true}
                        />
                        <hr />
                        <TestesCorrida {id_usuario} {id_assessoria} />
                    {/if}
                </Accordion.Item>

                <Accordion.Item value={"ANAMNESE"}>
                    <div slot="control">
                        <Title order={4} color="#3659fc">{"ANAMNESE"}</Title>
                    </div>

                    {#if id_usuario}
                        <Anamneses {id_usuario} ReadOnly={true} />
                    {/if}
                </Accordion.Item>
                {/if}
            </Accordion>
        </div>

        <br />
        <br />
        <br />
        <br />
        <br />
    {/if}
</div>

<style>
    .back {
        background-color: #e6e8f3;
    }
</style>
